export default __webpack_public_path__ + "static/help_02_02_2-890794ce36140b99c48ce14ef0dfd14f.png";